import type { IBotNetworkInterface } from '../types/bot_interface';
import type { IBotNetwork, IToBotMessagePacket, IFeedback, t_network_types, t_socket_state } from '../types/network';

import { MessagingFacade } from '../facades/messaging_facade';

/**
 * does not send or receive messages
 */
export class NetworkNone implements IBotNetwork {
  /**
   * if the network already in streaming of a message, we need to disable the send button
   */
  __inStreaming = false;
  constructor(public stateInterface?: IBotNetworkInterface, public messagingFacade?: MessagingFacade) {}

  /**
   * it is never a none connection because this does not exist as a valid option
   */
  static isOf(uri: string): boolean {
    return false;
  }

  async startup() {
    return this;
  }

  async shutdown() {
    return this;
  }

  public get inStreaming(): boolean {
    return this.__inStreaming;
  }

  send(packet: IToBotMessagePacket) {
    return Promise.resolve(packet);
  }

  ofType(type: t_network_types): type is 'none' {
    return false;
  }

  sendFeedback(feedback: IFeedback, uri?: string) {
    return Promise.resolve({});
  }

  /**
   * @returns connection state
   */
  getState(): t_socket_state {
    return 'open';
  }
}
